import { render } from "./AppHeader.vue?vue&type=template&id=68bf1bc6&scoped=true&ts=true"
import script from "./AppHeader.vue?vue&type=script&lang=ts"
export * from "./AppHeader.vue?vue&type=script&lang=ts"

import "./AppHeader.vue?vue&type=style&index=0&id=68bf1bc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bf1bc6"]])

export default __exports__